(function () {
  'use strict';
  function money(pence, compact) {
    return new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP',minimumFractionDigits:compact && pence % 100 === 0 ? 0 : 2,maximumFractionDigits:2}).format(pence / 100);
  }
  function schedule(total) {
    var regular = Math.round(total / 12);
    return {regular:regular, final:total - regular * 11};
  }
  function menuOpen() {
    return !!document.querySelector('#Details-menu-drawer-container[open]');
  }
  function watchNavigation() {
    function sync() {
      var open = menuOpen();
      if (document.body.classList.contains('lmb-navigation-open') !== open) document.body.classList.toggle('lmb-navigation-open', open);
      document.dispatchEvent(new CustomEvent('lmb:overlay-change'));
    }
    var root = document.querySelector('#Details-menu-drawer-container');
    if (root) new MutationObserver(sync).observe(root, {attributes:true,attributeFilter:['open','class']});
    document.querySelectorAll('cart-drawer, #CartDrawer').forEach(function (drawer) {
      new MutationObserver(sync).observe(drawer, {attributes:true,attributeFilter:['class','open']});
    });
    sync();
  }
  function init() {
    var panel = document.querySelector('[data-lmb-purchase]');
    if (!panel || panel.dataset.ready) return;
    var purchaseScope = panel.closest('[id^="ProductInfo-"]') || document;
    var nativeBlock = purchaseScope.querySelector('.product-add-cart-block');
    var nativeButton = nativeBlock && nativeBlock.querySelector('.add-to-cart-btn');
    if (!nativeButton) return;
    var initial;
    try { initial = JSON.parse(panel.querySelector('[data-payment-initial]').textContent); } catch (error) { return; }
    var labels = initial.labels;
    var quote = initial;
    var example = initial.example;
    // Keep the native purchase block after its product options. Never move it into pricing.
    document.documentElement.classList.add('lmb-purchase-enhanced');
    document.body.classList.add('lmb-purchase-enhanced');
    panel.dataset.ready = 'true'; panel.hidden = false;
    nativeButton.setAttribute('data-available-label', labels.add);
    var sticky = document.createElement('aside');
    sticky.className = 'lmb-payment-sticky'; sticky.hidden = true; sticky.setAttribute('aria-label', panel.getAttribute('aria-label'));
    sticky.innerHTML = '<div class="lmb-payment-sticky__inner"><div class="lmb-payment-sticky__summary"><p class="lmb-payment-sticky__total"><span data-sticky-total-label></span><strong data-sticky-total></strong></p><p class="lmb-payment-sticky__monthly"><strong data-sticky-monthly></strong><span data-sticky-suffix></span></p></div><button type="button" class="lmb-payment-sticky__button" data-sticky-add></button></div>';
    document.body.appendChild(sticky);
    var stickyButton = sticky.querySelector('[data-sticky-add]');
    var dialog = panel.querySelector('[data-payment-dialog]');
    var lastTrigger;
    function text(selector, value) { var node = panel.querySelector(selector) || sticky.querySelector(selector); if (node) node.textContent = value; }
    function reserveSpace() {
      var height = sticky.hidden ? 0 : Math.ceil(sticky.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--lmb-payment-bar-height', height + 'px');
    }
    function visibility() {
      var rect = nativeButton.getBoundingClientRect();
      var visible = rect.top >= 0 && rect.bottom <= window.innerHeight;
      var cartOpen = !!document.querySelector('cart-drawer.active, #CartDrawer.active, .quick-add-modal[open]');
      sticky.hidden = window.scrollY < 180 || visible || dialog.open || menuOpen() || cartOpen;
      reserveSpace();
    }
    function render(next) {
      if (!next) return;
      quote = Object.assign({}, initial, next);
      var valid = Number.isSafeInteger(quote.totalPence) && quote.totalPence > 0 && quote.variantId;
      var available = valid && quote.available !== false;
      var prefix = quote.from ? labels.from + ' ' : '';
      var monthly = valid ? schedule(quote.totalPence) : null;
      var finance = example && valid && quote.totalPence <= (initial.financeMaxPence || 300000);
      panel.querySelector('.lmb-purchase__monthly-block').hidden = !finance;
      panel.querySelector('[data-payment-eligibility]').hidden = !finance;
      sticky.querySelector('.lmb-payment-sticky__monthly').hidden = !finance;
      text('[data-payment-monthly]', valid ? prefix + money(monthly.regular) : labels.choose);
      text('[data-sticky-monthly]', valid ? prefix + money(monthly.regular) : labels.choose);
      text('[data-sticky-suffix]', ' ' + labels.monthly);
      text('[data-payment-total-label]', prefix);
      text('[data-sticky-total-label]', prefix);
      text('[data-payment-total]', valid ? money(quote.totalPence, true) : labels.choose);
      text('[data-sticky-total]', valid ? money(quote.totalPence, true) : labels.choose);
      text('[data-payment-selection]', quote.selectionText || '');
      var delivery = panel.querySelector('[data-payment-delivery]');
      if (delivery) delivery.textContent = available ? delivery.getAttribute('data-delivery-default') : labels.unavailable;
      var saving = valid && Number.isSafeInteger(quote.comparePence) ? quote.comparePence - quote.totalPence : 0;
      panel.querySelector('[data-payment-savings]').hidden = saving <= 0;
      panel.querySelector('[data-payment-saving]').hidden = saving <= 0;
      text('[data-payment-previous]', saving > 0 ? money(quote.comparePence, true) : '');
      text('[data-payment-saving]', saving > 0 ? labels.save + ' ' + money(saving, true) : '');
      stickyButton.disabled = !available;
      stickyButton.textContent = !valid ? labels.choose : available ? labels.add : labels.unavailable;
      nativeButton.setAttribute('aria-disabled', available ? 'false' : 'true');
      nativeButton.setAttribute('tabindex', available ? '0' : '-1');
      if (available && !nativeButton.hasAttribute('href')) nativeButton.setAttribute('href', '#');
      var nativeLabel = nativeButton.querySelector('.lmb-cart-button-label');
      if (nativeLabel) nativeLabel.textContent = !valid ? labels.choose : available ? labels.add : labels.unavailable;
      var quantity = nativeBlock.querySelector('#quantity');
      if (quantity) quantity.disabled = !available;
      text('[data-dialog-selection]', quote.selectionText || '');
      text('[data-dialog-total]', valid ? money(quote.totalPence) : labels.choose);
      panel.querySelector('[data-dialog-example]').hidden = !finance;
      text('[data-dialog-schedule]', valid ? (monthly.regular === monthly.final ? '12 × ' + money(monthly.regular) : '11 × ' + money(monthly.regular) + ' + ' + money(monthly.final)) + ' = ' + money(quote.totalPence) : labels.choose);
      visibility();
    }
    stickyButton.addEventListener('click', function () {
      if (!stickyButton.disabled && !nativeButton.classList.contains('loading') && nativeButton.getAttribute('aria-disabled') !== 'true') nativeButton.click();
    });
    panel.querySelector('[data-payment-open]').addEventListener('click', function (event) { lastTrigger = event.currentTarget; dialog.showModal(); visibility(); dialog.querySelector('[data-payment-close]').focus(); });
    panel.querySelectorAll('[data-payment-close]').forEach(function (button) { button.addEventListener('click', function () { dialog.close(); }); });
    dialog.addEventListener('close', function () { visibility(); if (lastTrigger) lastTrigger.focus(); });
    document.addEventListener('lmb:purchase-quote', function (event) { render(event.detail); });
    document.addEventListener('lmb:overlay-change', visibility);
    window.addEventListener('scroll', visibility, {passive:true}); window.addEventListener('resize', visibility, {passive:true});
    if (window.ResizeObserver) new ResizeObserver(reserveSpace).observe(sticky);
    render(window.lmbLatestPurchaseQuote || initial);
  }
  function ready() {
    // Keep an unpublished preview bookmarkable after Shopify consumes its query parameter.
    var previewId = document.body.getAttribute('data-lmb-preview-theme-id');
    if (previewId && /^https?:$/.test(window.location.protocol) && !(window.Shopify && Shopify.theme && Shopify.theme.role === 'main')) {
      var previewUrl = new URL(window.location.href);
      if (!previewUrl.searchParams.has('preview_theme_id')) {
        previewUrl.searchParams.set('preview_theme_id', previewId);
        window.history.replaceState(window.history.state, '', previewUrl.href);
      }
    }
    watchNavigation(); init();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  document.addEventListener('shopify:section:load', init);
})();
